<template>
  <div class="con">
    <img class="companyImage" src="@/assets/company/company1.jpg" />
    <p v-for="(x, i) in intro" :key="'x' + i" v-html="x"></p>
    <Diploma></Diploma>
    <br />
    <p v-for="(x, i) in intro2" :key="'y' + i" v-html="x"></p>
  </div>
</template>

<style scoped>
.con {
  width: 100%;
  text-align: center;
  padding-bottom: 32px;
}
.con > .companyImage {
  max-width: 100%;
}
.con > p {
  text-align: left;
  padding: 16px 32px;
  font-size: 16px;
  line-height: 28px;
  color: #303133;
  text-indent: 2em;
}

p >>> .highLight {
  font-weight: bold !important;
  color: #409eff !important;
  font-size: 20px !important;
}
p >>> .blod {
  font-weight: bold;
  font-size: 18px;
}
</style>

<script>
import Diploma from "@/components/company/Diploma.vue";
export default {
  components: {
    Diploma
  },
  data() {
    return {
      intro: [
        `<span class="highLight">大连世有电力科技有限公司</span>（原大连市金州仪器仪表厂）,位于辽宁省大连市金州区拥政街道胜利路947号,公司注册资金一亿元，经营范围：输配电控制设备、工业自动控制系统装置研发、制造及技术服务;电力工程、机电设备安装工程施工。`,
        `公司系科研、开发、生产于一体的国家级高新技术企业、省级企业技术中心、大连市输变电智能监控工程实验室、国家优势企业。公司与
        <span class="blod">北京大学</span>、
        <span class="blod">武汉光谷</span>、
        <span class="blod">中科院大连化物所</span>等院校技术合作
        ，走产、学、研一条龙道路，与<span class="blod">国网</span>、<span class="blod">南网</span>、各省电力公司等电力科学研究院合作，研发百余种输变电智能监测系统和测温保护装置。并取得几十项国家专利，其中发明专利9项，是7项国家机械行业标准主要起草人之一，是输变电用仪器仪表行业的领军企业， “金利”商标被认定为“中国驰名商标”。`,
        `
        公司科研成果被列为国家重点推广新产品，
        获大连市科技奖励一等奖，省、市科技成果奖、
        辽宁省优秀新产品奖、
        中国创新创业大赛大连赛区二等奖并进入行业总决赛、
        大连市专利奖、
        “中国电工协会十大创新产品”奖、
        辽宁省专精特新产品奖、辽宁省电力科学技术进步奖。
        公司被评为“中国中小企业优秀创新成果企业”、
        “中国自主创新百强企业” 、
        “辽宁省专精特新中小企业”、
        “辽宁省瞪羚企业”、
        “大连市十佳环境友好企业”，
        是中国输变电行业协会理事单位、
        国电招标网理事单位、
        中国百佳诚信投标企业。
        2019 年公司董事长王世有被任命为第十六届“中国科学家论坛副理事长”，被授予“2019 年中国科技创新领军人物”的称号，“世有”品牌被授予“2019 年中国科技创新品牌”， 并荣获“2019 年度国家知识产权优势企业”称号。
        `
      ],
      intro2: [
        `
        2019年国家电网公司全面推进<span class="blod">“智慧物联网”</span>建设部署，
        并将辽宁省电网虎石台变电站作为“智慧物联网”示范站，
        大连世有电力科技有限公司积极响应国家号召，
        全面加快“智慧物联网”的研发及技术推广，
        截止2019年9月，公司产品已陆续在辽宁省虎石台变电站投运，
        为虎石台变电站建立了“感知层、网络层、平台层、应用层”一套有序的运行示范平台并不断优化，
        有序的推进智慧物联网建设。
        `,
        `
        公司产品可替代进口产品，已广泛应用于<span class="blod">国网、南网、各省电力公司、电气化铁路、核电站、国家智能电网、大电网、物联网大数据等国家重点工程</span>；
        同时为国内外大型输变电厂商配套。
        产品成功应用于750kV超高压、晋东南世界顶级1000kV特高压变电站智能化监控、
        南澳岛世界首个多端柔性直流输电工程、
        大理局±800新松换流站等。公司产品适用于一带一路国家战略政策，已<span class="blod">远销美国、法国、西班牙、俄罗斯、加拿大、印度等以及亚太地区三十多个国家</span>，
        世有科技以高、精、尖、特、专的产品服务于全球，努力打造国内一流、世界知名的国家级高新技术企业。
        `,
        `
        大连世有电力科技有限公司董事长：<span class="highLight">王世有</span>，携全体员工向新老用户致意，欢迎国内外客商来人来电来函洽谈合作，共同发展，追求卓越。
        `
      ]
    };
  }
};
</script>
